import { Component, Input } from '@angular/core';

import { InfoModalService } from '../modal';
import { ParentWebsite, Step } from '@nx-ng/types';
import { Router } from '@angular/router';
import { RouteNames, ROUTE_TO_PAGE_NAME } from '@nx-ng/constants';
import { environment } from '@environment';
import { CheckoutStoreFacade } from '@modules/checkout-store';
import { getParentWebsite } from '@nx-ng/util';
import { CoreFacade } from '@modules/core/core.facade';

@Component({
  selector: 'nx-ng-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent {
  @Input()
  basketItemsTotal = 0;

  @Input()
  currentStep: Step | undefined = undefined;

  @Input()
  showBreadcrumb = false;

  @Input()
  parentWebsite: ParentWebsite = 'west-midlands';

  parentWebsiteUrl = `${window.location.origin}/${getParentWebsite()}`;

  public routenames = RouteNames;

  constructor(
    private infoModalService: InfoModalService,
    public checkoutFacade: CheckoutStoreFacade,
    public coreFacade: CoreFacade,
    private router: Router
  ) {}

  get currentRoute(): RouteNames {
    if (this.router.url.length < 2) {
      return RouteNames.PAGE_NOT_FOUND;
    }
    return this.router.url.slice(1) as RouteNames;
  }

  get currentPageTitle(): string {
    if (this.currentRoute.includes('confirmation')) {
      return ROUTE_TO_PAGE_NAME.confirmation;
    }

    return ROUTE_TO_PAGE_NAME[this.currentRoute];
  }

  get showCurrentPageIndicator() {
    return (
      this.currentRoute !== RouteNames.BOOKING_CONFIRMATION &&
      this.currentRoute !== RouteNames.PAGE_NOT_FOUND
    );
  }

  get showBackButton() {
    return !this.currentRoute.includes(RouteNames.BOOKING_CONFIRMATION);
  }

  get showBasket() {
    return (
      this.currentRoute !== RouteNames.BOOKING_CONFIRMATION &&
      this.currentRoute !== RouteNames.PAGE_NOT_FOUND
    );
  }

  get logo() {
    if (this.parentWebsite === 'west-midlands') {
      return `${environment.cdnBaseUrl}/app/assets/logo_nxwm_header_323x36.png`;
    } else if (this.parentWebsite === 'coventry') {
      return `${environment.cdnBaseUrl}/app/assets/logo_nxcov_header_261x44.png`;
    }
    return '';
  }

  get logoAltText() {
    if (this.parentWebsite === 'west-midlands') {
      return 'National Express West Midlands';
    } else if (this.parentWebsite === 'coventry') {
      return `National Express Coventry`;
    }
    return '';
  }

  handleBasketClicked = () => this.infoModalService.basket();
}
